import { t } from '../../i18n.es.js';
import React, { useState } from 'react';
import { styled, Checkbox } from '@teko/ui';

const GroupTitle = styled.p`
  font-size: 0.8125rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: #434657;
  line-height: 1.125rem;
`;
const Text = styled.p`
  font-size: 0.8125rem;
  font-weight: 400;
  color: #434657;
  margin: 0;
  margin-left: 0.5rem;
  cursor: pointer;
  line-height: 1.125rem;
  flex: 1;
`;
const Group = styled.div`
  &:not(:last-child) {
    margin-bottom: 1.5rem;
  }
`;
const Option = styled.div`
  display: flex;
  align-items: center;
  &:not(:last-child) {
    margin-bottom: 1rem;
  }
`;
const StyledCheckbox = styled(Checkbox)`
  margin: 0;
  border-radius: 2px;
`;
const GroupDescription = styled.p`
  margin: 0;
  font-size: 0.8125rem;
  color: #82869e;
  font-weight: 400;
  margin-top: -8px;
  margin-bottom: 1rem;
`;
const Alternative = styled.textarea`
  margin-top: 0.25rem;
  width: 100%;
  border-color: #e4e5f0;
  border-radius: 0.25rem;
  padding: 0.5rem;
  resize: none;
  color: #434657;
`;
const AlternativeTitle = styled.span`
  display: inline-block;
  font-size: 0.8125rem;
  line-height: 1.5rem;
  font-weight: 500;
  color: #434657;
`;
const SelectionGroup = ({
  title,
  options,
  onSelect,
  checked,
  type = "checkbox",
  alternative = false,
  description,
  onChangeReason,
  otherReason
}) => {
  const isCheckReason = () => alternative && checked.includes(options[options.length - 1].id);
  const [reason, setReason] = useState(otherReason);
  const handleChange = (event) => {
    const value = event.target.value;
    setReason(value);
    onChangeReason == null ? void 0 : onChangeReason(value);
  };
  const handleSelect = (id) => () => {
    onSelect(id);
  };
  return /* @__PURE__ */ React.createElement(Group, null, title && /* @__PURE__ */ React.createElement(GroupTitle, null, title), description && /* @__PURE__ */ React.createElement(GroupDescription, {
    dangerouslySetInnerHTML: { __html: description }
  }), options.map(({ text, id }) => /* @__PURE__ */ React.createElement(Option, {
    key: id
  }, /* @__PURE__ */ React.createElement(StyledCheckbox, {
    onClick: handleSelect(id),
    checked: checked.includes(id),
    circle: type === "radio",
    width: "1rem",
    height: "1rem"
  }), /* @__PURE__ */ React.createElement(Text, {
    onClick: handleSelect(id),
    dangerouslySetInnerHTML: { __html: text }
  }))), isCheckReason() && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(AlternativeTitle, null, t("Nh\u1EADp l\xFD do")), /* @__PURE__ */ React.createElement(Alternative, {
    spellCheck: false,
    placeholder: "Text...",
    rows: 3,
    onChange: handleChange,
    value: reason
  })));
};

export { SelectionGroup };
